__turbopack_context__.v({
  "empty-picture": "EmptyPicture-module-scss-module__1KBDIW__empty-picture",
  "empty-picture-icon-container": "EmptyPicture-module-scss-module__1KBDIW__empty-picture-icon-container",
  "required-label": "EmptyPicture-module-scss-module__1KBDIW__required-label",
});
